import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { useBranding, resolveAppDisplayName } from "../../context/BrandingContext";

export default function SellerOnboard() {
  const { user, refresh } = useAuth();
  const { branding } = useBranding();
  const [form, setForm] = useState({ shop_name: "", bio: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="px-6 py-24 text-center">
        <h1 className="font-display text-4xl mb-4">Sign in to become a seller</h1>
        <p className="text-[hsl(var(--kb-muted))]">Use the sign-in button in the header.</p>
      </div>
    );
  }
  if (user.role === "admin") return <div className="px-6 py-24 text-center">Admins cannot be sellers.</div>;
  if (user.role === "seller") return (
    <div className="px-6 py-24 text-center">
      <h1 className="font-display text-4xl mb-4">You're already a seller.</h1>
      <button className="kb-btn-primary" onClick={() => navigate("/seller")}>Go to dashboard</button>
    </div>
  );

  const submit = async (e) => {
    e.preventDefault();
    if (!form.shop_name) return toast.error("Shop name required");
    setLoading(true);
    try {
      await api.post("/auth/become-seller", form);
      await refresh();
      toast.success("Application submitted. Pending admin approval.");
      navigate("/seller");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="px-6 md:px-12 lg:px-24 py-20 max-w-3xl mx-auto" data-testid="seller-onboard-page">
      <div className="overline mb-3">For Ateliers</div>
      <h1 className="font-display text-4xl lg:text-6xl mb-6 leading-tight">Sell on {resolveAppDisplayName(branding)}.</h1>
      <p className="text-[hsl(var(--kb-muted))] leading-relaxed mb-10">
        Reach a community of patrons looking for heirloom and contemporary couture. We charge a flat 10% platform fee — everything else is yours.
      </p>
      <form onSubmit={submit} className="space-y-8 max-w-xl">
        <div>
          <label className="overline mb-2 block">Shop Name</label>
          <input className="kb-input" value={form.shop_name} onChange={(e) => setForm({ ...form, shop_name: e.target.value })} placeholder="e.g. Nayaab Atelier" data-testid="shop-name-input" />
        </div>
        <div>
          <label className="overline mb-2 block">About your studio</label>
          <textarea className="kb-input" rows={4} value={form.bio} onChange={(e) => setForm({ ...form, bio: e.target.value })} placeholder="Your craft, origin, story…" data-testid="shop-bio-input" />
        </div>
        <button className="kb-btn-primary" disabled={loading} data-testid="seller-apply-btn">
          {loading ? "Submitting…" : "Apply to sell"}
        </button>
      </form>
    </div>
  );
}
